import {
  ChangeDetectionStrategy,
  Component,
  input,
  InputSignal,
} from '@angular/core';
import { SkeletonTextComponent } from '@lyceo/shared/ui';

@Component({
  selector: 'homi-data-list-value',
  templateUrl: 'data-list-value.component.html',
  styleUrls: ['data-list-value.component.scss'],
  imports: [SkeletonTextComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DataListValueComponent {
  public readonly loading: InputSignal<boolean> = input<boolean>(false);
}
